angular
	.module 'App.Module.User', []
	.config ($stateProvider, DEFAULT_RESOLVE_POLICY, SEARCH_CONFIGURATION) ->
		$stateProvider
			.state 'users',
				url: '/users',
				views:
					main:
						templateUrl: '@app/layout/views/app.entity-administration.view.html'
						controller: 'MainCrudController'
						controllerAs: 'mainCrud'
					'entity_search@users':
						templateUrl: '@app/layout/views/app.entity-search.view.html'
						controller: 'BaseSearchController'
						controllerAs: 'search'
				data:
					searchParams:
						advanced:
							configuration: SEARCH_CONFIGURATION.user
						repositoryName: 'UserRepository'
						attribute: 'full_name'
						title: 'general.users'
					restrict: 'Backoffice.TopMenu.Users.Users'

			.state 'users.edit',
				url: '/:id'
				abstract: true
				views:
					entity_view:
						templateUrl: '@app/layout/views/app.entity-container.view.html'

				resolvePolicy: DEFAULT_RESOLVE_POLICY
				resolve:
					user: (UserRepository, $stateParams) ->
						return UserRepository.getEntity($stateParams.id)
					roles: (UserRoleRepository) ->
						return UserRoleRepository.getEntities()
					shopsList: (ShopRepository) ->
						return ShopRepository.getEntities()

			.state 'users.edit.details',
				url: '/details',
				views:
					entity_sub_view:
						controller: 'UserController'
						controllerAs: 'vm'
						templateUrl: '@app/user/user.view.html'
